import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { App, AppState } from '@capacitor/app';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';

@Component({
  selector: 'app-location-settings',
  templateUrl: './location-settings.component.html',
  styleUrls: ['./location-settings.component.scss'],
})
export class LocationSettingsComponent implements OnInit, OnDestroy {

  private unregisterBackButtonAction: any;
    public backgroundClass = "blue-background";
    public addStars = true;
    public locationMessage: string;
    androidPhoneGeoCheck=true;
    private defaultLocationMessages = {
      ios: "Open your device's Settings, select 'Privacy', and switch on Location Services to let Stardust Social access your location.",
      android:"Stardust Social Casino collects location data to allow play from specific regions only. The app uses your location in the background to determine if your region is eligible to use this app",
      other: "Stardust Social Casino collects location data to allow play from specific regions only. The app uses your location in the background to determine if your region is eligible to use this app",
   };
    constructor(
        protected platform: Platform,
        private navigator: Navigator,
        private eventService: EventsService,
        private appStorageService: AppstorageTsService,
        private configService: ConfigService
    ) {
      
    }

    ngOnInit(){
      this.loadLocationMessages();
    }

    ionViewDidLoad() {
      this.initializeBackButtonCustomHandler();
    }

    ionViewDidEnter(){
      App.addListener('appStateChange', (state: AppState) => {
        if (state.isActive) {
          // The app became active (user came back to the app)
          console.log('App became active');
        } else {
          // The app is in the background
          console.log('App is in the background');
        }
      });
    }

    ionViewWillLeave() {
        this.unregisterBackButtonAction && this.unregisterBackButtonAction();
    }

    initializeBackButtonCustomHandler() {
        // old this.unregisterBackButtonAction = this.platform.registerBackButtonAction(function(event){
        this.platform.backButton.subscribeWithPriority(101, (event) => {
            console.log('Prevent Back Button Page Change... You Stuck!');
        },); // Priority 101 will override back button handling (we set in app.component.ts) as it is bigger then priority 100 configured in app.component.ts file */
    }
    loadLocationMessages() {
      try {
        const config = this.configService.getConfig();
       
        if (config && config.FEATURE_LOCATION_MESSAGES) {
          const configMessages = JSON.parse(config.FEATURE_LOCATION_MESSAGES);
          this.setLocationMessage(configMessages);
        
        } else {
          console.warn('Location messages config not found. Using default messages.');
          this.setLocationMessage(this.defaultLocationMessages); 
        }
      } catch (error) {
        console.error('Error parsing location messages config:', error);
        this.setLocationMessage(this.defaultLocationMessages); 
      }
    }
   
    setLocationMessage(configMessages) {
 
      if (this.platform.is('ios')) {
        this.locationMessage = configMessages.ios || this.defaultLocationMessages.ios;
      } else if (this.platform.is('android')) {
        this.locationMessage = configMessages.android || this.defaultLocationMessages.android;
      } else {
        this.locationMessage = configMessages.other || this.defaultLocationMessages.other;
      }
    }
    cancel(){
      return this.navigator.navigateTo("AppRestrictedComponent", { customModalClass: 'app-restricted-screen', animated: false });
    }
    ngOnDestroy(){
      App.removeAllListeners();
    }


}
